"use client";

import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/constants/queryKeys";
import api from "@/actions/api";
import { useStableSearchParams } from "../customSearchParams/useCustom";
import useStableParams from "../customSearchParams/useStableParams";
import { clearUnwantedSearchParamsUrl } from "@/utils/urlManipulation";
export function useLocationsRealEstateByCoords(t0) {
  const $ = _c(20);
  const {
    coords,
    realEstateIds
  } = t0;
  const searchParams = useStableSearchParams();
  const stableParams = useStableParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = clearUnwantedSearchParamsUrl(searchParams, ["modal"]);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cleanSearchParams = t1;
  let t2;
  if ($[2] !== realEstateIds) {
    t2 = realEstateIds?.join(",") ?? "";
    $[2] = realEstateIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== coords.lat || $[5] !== coords.lng || $[6] !== stableParams || $[7] !== t2) {
    t3 = [QueryKeys.LOCATION_BY_COORDS_REAL_ESTATE, stableParams, coords.lat, coords.lng, t2];
    $[4] = coords.lat;
    $[5] = coords.lng;
    $[6] = stableParams;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== cleanSearchParams || $[10] !== coords || $[11] !== realEstateIds) {
    t4 = t5 => {
      const {
        pageParam: t6
      } = t5;
      const pageParam = t6 === undefined ? 1 : t6;
      return api.locations.getLocationsRealEstateByCoords({
        searchParams: cleanSearchParams,
        page: pageParam,
        coords,
        ids: realEstateIds
      });
    };
    $[9] = cleanSearchParams;
    $[10] = coords;
    $[11] = realEstateIds;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = !!coords;
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      getNextPageParam: _temp,
      initialPageParam: 1
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const query = useInfiniteQuery(t6);
  const totalItems_0 = query.data?.pages[0]?.metadata?.pagination?.total || 0;
  let t7;
  if ($[17] !== query || $[18] !== totalItems_0) {
    t7 = {
      ...query,
      totalItems: totalItems_0
    };
    $[17] = query;
    $[18] = totalItems_0;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(lastPage) {
  const {
    metadata
  } = lastPage;
  const first = metadata?.pagination?.first || 0;
  const totalItems = Number(metadata?.pagination?.total || 0);
  if (!metadata?.pagination?.perPage) {
    return;
  }
  const currentPage = Math.floor(first / metadata?.pagination?.perPage) + 1;
  const totalPages = Math.ceil(totalItems / metadata?.pagination?.perPage);
  return currentPage < totalPages ? currentPage + 1 : undefined;
}